// WhatsAppIcon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './WhatsAppIcon.css'; // Styles for the icon

const WhatsAppIcon = () => {
  const handleWhatsAppClick = () => {
    // Handle WhatsApp click event (e.g., open WhatsApp chat)
    window.open('https://wa.me/+447413402742', '_blank');
  };

  return (
    <div className="whatsapp-icon" onClick={handleWhatsAppClick}>
      <FontAwesomeIcon icon={faWhatsapp} />
    </div>
  );
};

export default WhatsAppIcon;
